import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrainingRouterModule } from './training.routes';
import { Views } from '@training/views';
import { AppCommonModule } from '@common/common.module';
import { PlatformModule } from '@app/platform.module';
import { FormsModule } from '@angular/forms';
import { TrainingResolver } from './training.resolver';
import { Services } from './services';
import { TableModule } from '@app/modules/table/table.module';
import { EmployeeFormsModule } from '../forms/employees/employee-forms.module';
import { TrainingFormsModule } from '../forms/training/training-forms.module';

@NgModule({
    declarations: [...Views],
    imports: [
        CommonModule,
        TrainingRouterModule,
        AppCommonModule,
        PlatformModule,
        FormsModule,
        TableModule,
        EmployeeFormsModule,
        TrainingFormsModule,
    ],
    providers: [TrainingResolver, ...Services],
})
export class TrainingModule {}
